import {
  Button, Card, CardContent,
  CardHeader,
  CircularProgress,
  Container,
  Dialog,
  DialogActions, DialogContent, DialogContentText, DialogTitle,
  Divider,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { makeStyles } from '@material-ui/styles';
import moment from 'moment';
import React, { useState } from 'react';
import Header from 'src/components/Header';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';


const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  todos: {
    marginTop: theme.spacing(1)
  },
  contentMaterialImage: {
    padding: 5,
    minHeight: 580,
  },
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  submitMaterialImage: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
  container: {
    maxHeight: 440,
  },
}));

function OpenWork() {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [Uyari] = React.useState("");
  const [ResponseData, setResponseData] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const today = moment(new Date()).format('YYYY-MM-DD');
  const [baslangicTarihi] = React.useState(today);
  const [bitisTarihi] = React.useState(today);

  const [ToplamAdet, setToplamAdet] = useState(0);






  const SessionUser = getUser();
  const handleClose = () => {
    setOpen(false);
  };

  const handleSearch = () => {
    // if (getDifferenceInDays(new Date(baslangicTarihi), new Date(bitisTarihi)) > 30) {
    //   setUyari("İki tarih aralığı 30 günden büyük olamaz!...");
    //   setOpen(true);
    //   return
    // }
    setLoading(true);
    axios.get('/GetOpenWorkReport/' + SessionUser.ServiceShopId + '/' + SessionUser.OrganizationUserId + '/' + baslangicTarihi + '/' + bitisTarihi)
      .then(response => {
        const Data = response.data;
        if (Data.length === 0) {
          setResponseData([]);
        } else {
          setResponseData(Data);
          var ToplamAdet1 = Data.reduce((a, v) => a = a + parseFloat(v.ADET), 0);
          setToplamAdet(ToplamAdet1);
        }

        setLoading(false);
      }).catch(_error => {
        setResponseData([]);
        setLoading(false);
      });
  }

  var labelsSP = [];
  var dataSP = [];
  ResponseData.forEach(item => {
    labelsSP.push(item.DURUM);
    dataSP.push(item.ADET);
  });



  return (
    <Page className={classes.root} title="Açık İşler">
      <Container maxWidth="lg">
        <Header />
        <Card>
          <CardHeader title="Açık İşler" />
          <Divider />
          <CardContent>
            {loading && <CircularProgress
              status={'loading'}
              style={{ marginLeft: '50%' }}
            />}
            <br />
            <Grid container spacing={1}>
              {/* <Grid item xs={6} sm={6}>
                <ThemeProvider theme={materialTheme}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap["tr"]}>
                    <KeyboardDatePicker
                      color="primary"
                      inputVariant="outlined"
                      label={'Başlangıç Tarihi'}
                      invalidDateMessage={'Hatalı Tarih Formatı'}
                      format={'dd.MM.yyyy'}
                      variant="outlined"
                      value={baslangicTarihi}
                      onChange={e => handleDateChange(e, 1)}
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </ThemeProvider>
              </Grid>
              <Grid item xs={6} sm={6}>
                <ThemeProvider theme={materialTheme}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap["tr"]}>
                    <KeyboardDatePicker
                      color="primary"
                      inputVariant="outlined"
                      label={'Bitiş Tarihi'}
                      invalidDateMessage={'Hatalı Tarih Formatı'}
                      format={'dd.MM.yyyy'}
                      variant="outlined"
                      value={bitisTarihi}
                      onChange={e => handleDateChange(e, 2)}
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </ThemeProvider>
              </Grid> */}
              <Grid item xs={12} sm={12}>
                <Button
                  variant="contained"
                  color="secondary"
                  className={classes.submitMaterialImage}
                  onClick={() => handleSearch()}
                  endIcon={<SearchIcon />}>
                  Sorgula
                </Button>
              </Grid>
            </Grid>
            <br />
            <Divider />
            <br />
          </CardContent>

        </Card>
        <br />
        <Card>
          <TableContainer className={classes.container}>
            <Table stickyHeader aria-label="sticky table" size="small">
              <TableHead>
                <TableRow>
                  <TableCell align='center'>Toplam Açık Fiş Adedi : {ToplamAdet}</TableCell>
                </TableRow>
              </TableHead>
            </Table>
          </TableContainer>
          <TableContainer className={classes.container}>
            <Table stickyHeader aria-label="sticky table" size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Durum</TableCell>
                  <TableCell align='right'>Adet</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {ResponseData.sort((a, b) => a.ADET > b.ADET ? -1 : 1).map(row => (
                  <TableRow key={row.DURUM}>
                    <TableCell>{row.DURUM}</TableCell>
                    <TableCell align='right'>{row.ADET}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Card>
        {/* <Card>
            {ResponseData.length > 0 ? 
            <Chart type={'bar'} options={optionsbar}data={data}  height={500}/> 
            : ""}
        </Card> */}

      </Container>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description" >
        <DialogTitle id="alert-dialog-slide-title" color="primary">{"Bilgilendirme"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {Uyari}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Tamam
          </Button>
        </DialogActions>
      </Dialog>
    </Page>
  );
}

export default OpenWork;
